import { Actor, Character, Project } from '@types';

export class VideoRequestModel implements Actor.VideoRequest {
    id: number = null;
    project_id: number = null;
    character_id: number = null;
    script: string = null;
    instructions: string = null;
    videos: Actor.Video[] = null;
    project: Project = null;
    character: Character = null;
    emailRequests: any[] = [];
    constructor({
        id,
        project_id,
        character_id,
        script,
        instructions,
        project,
        videos,
        character,
        emailRequests,
    }: Actor.VideoRequest) {
        this.id = id;
        this.project_id = project_id;
        this.character_id = character_id;
        this.script = script;
        this.instructions = instructions;
        this.project = project;
        this.videos = videos;
        this.character = character;
        this.emailRequests = emailRequests;
    }
}
